<script lang="ts">
    import '../../css/app.pcss';
    import { QueryClientProvider } from '@tanstack/svelte-query';
    import { dev } from '$app/environment';
    import type { LayoutData } from './$types';
    import { PUBLIC_CANONICAL_HOST, PUBLIC_POSTHOG_KEY } from '$env/static/public';
    import { page } from '$app/stores';
    import { isPreviewDeployment } from '$lib/util/util';
    import ToastContainer from '$lib/components/util/ToastContainer.svelte';
    import MousePositionContext from '$lib/components/util/MousePositionContext.svelte';
    import posthog from 'posthog-js';
    import { onMount } from 'svelte';
    import { distinctId } from '$lib/stores.js';

    export let data: LayoutData;

    let posthogInitialized = false;
    function initPosthog() {
        if (posthogInitialized) return;

        posthogInitialized = true;
        posthog.init(PUBLIC_POSTHOG_KEY, {
            api_host: 'https://events.lewo-media.de',
            ui_host: 'https://eu.i.posthog.com',
            person_profiles: 'identified_only',
            autocapture: true,
            loaded: (posthog_instance) => distinctId.set(posthog_instance.get_distinct_id())
        });
    }

    type KlaroConsents = 'posthog';
    function onKlaroLoaded() {
        /*
        if (dev) {
            return;
        }
         */

        if (window.klaro?.getManager().getConsent('posthog')) {
            initPosthog();
        }

        window.klaro?.getManager().watch({
            update: (object: unknown, name: string, data: Record<KlaroConsents, boolean>) => {
                if (name === 'consents') {
                    if (data.posthog) {
                        initPosthog();
                    }
                }
            }
        });
    }

    onMount(() => {
        if (window.klaro) {
            onKlaroLoaded();
        } else {
            window.klaroLoadWatchers ??= [];
            window.klaroLoadWatchers.push(onKlaroLoaded);
        }
    });

    function buildCanonicalUrl(pageUrl: URL) {
        const canonicalUrl = new URL(pageUrl.toString());
        canonicalUrl.host = PUBLIC_CANONICAL_HOST;
        canonicalUrl.port = '';
        canonicalUrl.protocol = 'https';

        return canonicalUrl;
    }

    $: canonicalUrl = buildCanonicalUrl($page.url);
</script>

<svelte:head>
    <link rel="canonical" href={canonicalUrl.toString()} />
    <script defer src="https://api.kiprotect.com/v1/privacy-managers/ebf183b89750baaa2f759ddaa569fb7d/klaro.js">
    </script>
</svelte:head>

<ToastContainer />
<QueryClientProvider client={data.queryClient}>
    <MousePositionContext>
        <slot />
    </MousePositionContext>
</QueryClientProvider>

{#if isPreviewDeployment}
    <div class="z-50 fixed bottom-0 left-0 p-2 bg-yellow-400">
        <p class="font-black">PREVIEW</p>
        <div class="flex justify-evenly">
            <a href="/de" data-sveltekit-reload>DE</a>
            <a href="/en" data-sveltekit-reload>EN</a>
        </div>
    </div>
{/if}
